export enum taxBracketsTypes {
  GET_ALL_TAX_BRAKETS = 'GET_ALL_TAX_BRAKETS',
  GET_TAX_BRAKET_BY_ID = 'GET_TAX_BRAKET_BY_ID',
  POST_TAX_BRACKET = 'POST_TAX_BRACKET',
  DELETE_TAX_BRACKET = 'DELETE_TAX_BRACKET',
  UPDATE_TAX_BRACKET = 'UPDATE_TAX_BRACKET',
}
